module.exports = __webpack_public_path__ + "media/images/action_against_hunger-8fcd6d67ecfafd189127a3d87eb8d40b.png";